import React, { useState, useEffect }  from "react"
import Header from 'pages/Header/HeaderNavegacion';
import Footer from 'pages/Footer/FooterDesktop';
import BarraCP from 'components/BarCP/BarHeaderCP';
import styles from './styles.module.sass';
import { useIsMobile } from 'hooks/useIsMobile';

import { Link, useHistory, useLocation } from 'react-router-dom'
import Slider from "react-slick";

const timeQueryParam = () =>  {
    const date = new Date()
    const dateQP = `?${date.getFullYear()}${date.getMonth()}${date.getDate()}`
    return dateQP
}

const MenuSuperior = (props) => {
    const {
        respMenu
    } = props
    
    return(
        <menu className={styles?.contMenu}>
            {respMenu
                ?
                    respMenu?.map((menu, index) => {
                        const target = menu?.target === 'anchor' ? '_top' : '_blank'
                        const name = menu?.name.replace(/ /g,'_').toLowerCase()
                        const vinculo = menu?.target === 'anchor' ? `#${name}` : menu?.nav

                       return (
                            <li key={index}>
                                <Link to={vinculo} target={target} className={styles?.navMenu} >{menu?.name}</Link>
                            </li>
                        )
                    }
                    )
                : null
            }
        </menu>
    )
}

const BannerPrincipal = (props) => {
    const {
        respBannerSection,
        respBannerSectionMov,
        anchor
    } = props

    return(
        <>
            {
                respBannerSection &&
                    <div className={styles?.contentBannerDesktop}>
                        {
                            respBannerSection.map((banner,index) => {
                                const nameButton = banner?.title_Button || 'Únete'
                                return(
                                    <div 
                                        key={index} 
                                        className={styles?.contBannerPrincipal} 
                                        id={`${anchor}`}
                                    >
                                        <a 
                                            href={banner?.url} 
                                            target={banner?.target !== '_blank' ? '_top' : '_blank'}
                                        >
                                            <img src={banner?.img+timeQueryParam()} alt={banner?.name} />
                                        </a>
                                        {nameButton
                                            ? 
                                                banner?.target && banner?.target !== '_blank'
                                                    ?
                                                        <Link 
                                                            to={banner?.url} 
                                                            target={banner?.target !== '_blank' ? '_top' : '_blank'} 
                                                            className={styles?.btnBlack}>{nameButton}</Link>
                                                    :
                                                        <a 
                                                            href={banner?.url} 
                                                            target={banner?.target !== '_blank' ? '_top' : '_blank'} 
                                                            className={styles?.btnBlack}>{nameButton}</a>
                                            : null
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
            }

            {
                respBannerSectionMov &&
                    <div className={styles?.contentBannerMovil}>
                        {
                            respBannerSectionMov.map((banner,index) => {
                                const nameButton = banner?.title_Button || 'Únete'
                                return(
                                    <div 
                                        key={index} 
                                        className={styles?.contBannerPrincipalMov} 
                                        id={`${anchor}`}
                                    >
                                        <a 
                                            href={banner?.url} 
                                            target={banner?.target !== '_blank'  ? '_top' : '_blank'} 
                                        >
                                            <img src={banner?.logo+timeQueryParam()} alt={banner?.name} />
                                        </a>
                                        <p>{banner?.text}</p>
                                        <img src={banner?.img+timeQueryParam()} alt={banner?.text} />
                                        {nameButton
                                            ? 
                                                banner?.target && banner?.target !== '_blank' 
                                                    ?
                                                        <Link 
                                                            to={banner?.url} 
                                                            target={banner?.target !== '_blank' ? '_top' : '_blank'} 
                                                            className={styles?.btnBlack}>{nameButton}</Link>
                                                    :
                                                        <a 
                                                            href={banner?.url} 
                                                            target={banner?.target !== '_blank' ? '_top' : '_blank'} 
                                                            className={styles?.btnBlack}>{nameButton}</a>
                                            : null
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
            }
        </>
    )
}


const DescubreCliente = (props) => {

    const { isMobile } = useIsMobile();


    const {
        respDescubre,
        sliderView = null,
        slidesToS = 2,
        onlyMobile = false,
        anchor,
        centerMode = false,
        slideSliders = 'slider1'
    } = props

    const [ sliderViewInt, setSliderViewInt] = useState(sliderView)
    const [ settings, setSettings ] = useState()
    
    useEffect(()=>{
        if(!onlyMobile){
            let set = {
                infinite: true,
                arrows: true,
                dots: false,
                speed: 100,
                slidesToShow: slidesToS,
                slidesToScroll: 1,
                initialSlide: 0,
                centerMode: centerMode,
                variableWidth: false,
                className: styles[slideSliders],
                responsive: [
                    {
                        breakpoint: 800,
                        settings: {
                            slidesToShow: (slidesToS - 1),
                        }
                    }
                ]
            };
            setSettings(set)
        }else{
            if(isMobile !== 'desktop'){
                console.log('asdasdasdasds')
                let set = {
                    infinite: true,
                    arrows: false,
                    dots: true,
                    speed: 100,
                    slidesToShow: slidesToS,
                    slidesToScroll: 1,
                    initialSlide: 0,
                    centerMode: centerMode,
                    variableWidth: false,
                    className: styles[slideSliders],
                    responsive: [
                        {
                            breakpoint: 800,
                            settings: {
                                slidesToShow: (slidesToS - 1),
                            }
                        }
                    ]
                };
                setSettings(set)
            }else{
                setSliderViewInt(null)
            }
        }
    },[])


    return(
        respDescubre
            ?
                <div className={styles?.contDescubre}  id={`${anchor}`}>
                    <div className={styles?.contDescubreTitle}>
                        <h3>{respDescubre?.title}</h3>
                        {respDescubre?.subtitle &&
                            <p>{respDescubre?.subtitle}</p>
                        }
                    </div>
                    {sliderViewInt
                        ?
                            <Slider {...settings}>
                                {
                                    respDescubre?.items.map((slide, index) => {
                                        return(
                                            slide?.url
                                                ?
                                                    <a key={index} href={slide?.url} target={slide?.target} >
                                                        <img src={slide?.img+timeQueryParam()} alt={slide?.img} />
                                                    </a>
                                                :
                                                    <img key={index} src={slide?.img+timeQueryParam()} alt={slide?.img} />
                                        )
                                    })
                                }
                            </Slider>
                        :
                            <div className={styles?.imagesGrid}>
                                {respDescubre?.items?.length >= 1
                                    ? respDescubre?.items.map((slide, index) => {
                                        return(
                                            slide?.url
                                                ?
                                                    <a key={index} href={slide?.url} target={slide?.target}>
                                                        <img src={slide?.img+timeQueryParam()} alt={slide?.img} />
                                                    </a>
                                                :
                                                    <img key={index} src={slide?.img+timeQueryParam()} alt={slide?.img} />
                                        )
                                    })
                                    : null
                                }
                            </div>
                    }
                </div>
            : null
    )
}


const NuestraComunidad = (props) => {
    const {
        respComunidad,
        anchor
    } = props

    return(
        respComunidad
            ?
                <div className={styles?.contComunidad} id={`${anchor}`}>

                    <h4>{respComunidad?.title}</h4>
                    <div className={styles?.contVideoYT}>
                        {respComunidad?.items?.map((content, index) => 
                            <div className={styles?.videoYT} key={index}>
                                <iframe width="560" height="315" src={content?.video} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                            </div>
                        )}
                    </div>
                </div>
            : null
    )
}


export default function ClientePreferido() {

    const location = useLocation()
    const history = useHistory()
    const urlActual = window.location.href

    const [ dataCP, setDataCP ] = useState({})
    const [ respMenu, setRespMenu ] = useState()
    const [ respBannerSection, setRespBannerSection ] = useState()
    const [ respBannerSectionMov, setRespBannerSectionMov ] = useState()
    const [ respBeneficiosE, setRespBeneficiosE ] = useState()
    const [ reviveEventos, setReviveEventos ] = useState()
    const [ proximosEventos, setProximosEventos ] = useState()
    const [ favoritos, setFavoritos ] = useState()

    const getData = async () =>  {
        const config = {
            method: 'GET',
            withCredentials: true,
            redirect: 'follow',
            timeout: 25,
        }
        let host = 'https://resources.sears.com.mx/medios-plazavip'
        let apiURL = `${host}/swift/v1/staticJson/clientes_preferidos/cliente_preferido.json`
        try{
            const response = await fetch( apiURL, config )
            const data = await response.json();
            setDataCP(data)
        } catch (error) {
            console.error('Error fetching cmsProductGet data:', error);
        }
    }

    useEffect(()=>{
        getData()
    },[])

    useEffect(()=>{
        if(dataCP){
            if(dataCP?.status){
                if(dataCP?.sections?.length > 0){
                    const resp = dataCP?.sections

                    resp.map(section => {
                        if(section?.section_name === 'menu'){
                            setRespMenu(section?.items)
                        }
                        if(section?.section_name === 'hero'){
                            setRespBannerSection(section?.items)
                        }
                        if(section?.section_name === 'hero_movil'){
                            setRespBannerSectionMov(section?.items)
                        }
                        if(section?.section_name === 'carousel'){
                            setRespBeneficiosE(section)
                        }
                        if(section?.section_name === 'video'){
                            setReviveEventos(section)
                        }
                        if(section?.section_name === 'anuncios'){
                            setProximosEventos(section)
                        }
                        if(section?.section_name === 'carousel2'){
                            setFavoritos(section)
                        }
                    })
                }
            }
        }
    },[dataCP])

    //recibe la direccion del CP    
    const [updateCPBar, setUpdateCPBar] = useState();
    const changeDirectionBar = (val) => {
        setUpdateCPBar(val);
    };
    const [upCP, setUpCP] = useState();
    useEffect(()=>{
        if(upCP){
            //console.log('')
        }
    },[upCP,updateCPBar]);

    return(
        <>
            <Header setUpCP={setUpCP} changeDirectionBar={changeDirectionBar} />
            <section className="barCpResponsive">
                <BarraCP changeCP={changeDirectionBar} clase="barHeaderCP" />
            </section>

            <main>
                <section className='container'>
                    
                    <MenuSuperior 
                        respMenu={respMenu}
                    />
                    
                    <BannerPrincipal 
                        respBannerSection={respBannerSection}
                        respBannerSectionMov={respBannerSectionMov}
                        anchor={respMenu ? respMenu[0]?.name.replace(/ /g,'_').toLowerCase() : null}
                    />

                    <DescubreCliente 
                        respDescubre={respBeneficiosE}
                        sliderView={true}
                        slidesToS={3}
                        slideSliders='clientePreferidoSlider'
                        anchor={respMenu ? respMenu[1]?.name.replace(/ /g,'_').toLowerCase() : null}
                    />
                </section>

                <section className='container'>
                    <NuestraComunidad 
                        respComunidad={reviveEventos}
                        anchor={respMenu ? respMenu[2]?.name.replace(/ /g,'_').toLowerCase() : null}
                    />
                </section>

                <section className='container'>
                    <DescubreCliente 
                        respDescubre={proximosEventos}
                        sliderView={true}
                        slidesToS={2}
                        slideSliders='proximoslider'
                        onlyMobile={true}
                        anchor={respMenu ? respMenu[3]?.name.replace(/ /g,'_').toLowerCase() : null}
                    />
                </section>

                <section className='container'>
                    <DescubreCliente 
                        respDescubre={favoritos}
                        sliderView={true}
                        slidesToS={2}
                        slideSliders='favoritoSlider'
                        anchor={respMenu ? respMenu[4]?.name.replace(/ /g,'_').toLowerCase() : null}
                    />
                </section>
            </main>
            <Footer />
        </>
    )
}